/* eslint-disable no-sequences */
function showLoader() {
  document.querySelector(".overlay_spinner").style.display = "block";
}
function hideLoader() {
  document.querySelector(".overlay_spinner").style.display = "none";
}
function getQueryParams() {
  return window.location.search
    .replace("?", "")
    .split("&")
    .reduce(
      (r, e) => ((r[e.split("=")[0]] = decodeURIComponent(e.split("=")[1])), r),
      {}
    );
}

export { showLoader, hideLoader, getQueryParams };
